import React from "react";
import "./showcase.css";

function Showcase() {
  document.title = "Moons - Home";
  return (
    <div id="showcase-container">
      <img src="https://cdn.shopify.com/s/files/1/0046/7458/4645/files/banner_midnight_collection_text_large_31531790-5b54-4787-8191-bef9fcadcfe5_1296x.jpg?v=1630854161"></img>
    </div>
  );
}

export default Showcase;
